import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { RoutesConst } from '@uw/shared/contants/const-routes';
import { Observable } from 'rxjs';
import { Roles } from '../enums/role.enum';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UWAdminGuard  {

  constructor(private authService: AuthService, private route: Router){
   }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
       if ( this.authService.getUser() && (this.authService.getUser()?.roleCode === Roles.UnitedWayAdministrator
       || this.authService.getUser()?.roleCode === Roles.SystemAdministrator)) {
         return true;
       } else if ( this.authService.getUser()
       && this.authService.getUser()?.roleCode === Roles.WorkspaceAdministrator) { // todo: check workplaceTypeRole after campaign impmenetation
        let user = this.authService.getUser();

        if (user && user.workplaceRoleType === 'Campaign'){
          this.route.navigate([RoutesConst.CampaignList]);
        } else {
          this.route.navigate([RoutesConst.CompanyList]);
        }
        
        return true;
      }
       this.route.navigate(['/private/home']);
      return false;
  }

}
